import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs'
import { MatSidenav } from '@angular/material/sidenav';
import { StateService } from '../services/state/stateService';
import { JOB_ENTERED, TOGGLE_LEFT_MENU } from '../state/state';
import { PreloaderService } from '../template/shared/services/preloader/preloader.service';
import { SpinnerService } from '../template/shared/services/spinner/spinner.service';
import { TaskboardSidebarService } from '../taskboard/services/taskboardSidebar.service';

@Component({
  selector: '.content_inner_wrapper',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketingComponent implements OnInit, OnDestroy {
  //TEMPLATES
  @ViewChild('leftSidenav2', { static: true }) leftSidenav2: MatSidenav;

  navMode = 'side';
  private _subscriptions: Array<Subscription> = [];

  constructor(
    private _spinner: SpinnerService,
    private stateService: StateService,
    private sidebarService: TaskboardSidebarService
  ) {

  }

  ngOnInit() {
    if (window.innerWidth < 992) {
      this.navMode = 'over';
      this.leftSidenav2.opened = false;
    }
    if (window.innerWidth > 992) {
      this.navMode = 'side';
      this.leftSidenav2.open();
    }
    this._subscriptions.push(this.stateService.getStream(TOGGLE_LEFT_MENU).subscribe((t) => this.leftSidenav2.toggle()));
    this._subscriptions.push(this.stateService.subscribe(JOB_ENTERED, (res) => {
      if (res && res.jobId) {
        this.sidebarService.close();
      }
    }));
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
      this.navMode = 'over';
      this.leftSidenav2.close();
    }
    if (event.target.innerWidth > 992) {
      this.navMode = 'side';
      this.leftSidenav2.open();
    }
  }

  ngAfterViewInit() {
    PreloaderService.load().then(values => {
      this._spinner.hide();
    });
  }

  toggleIfSmallScreen() {
    if (this.navMode === 'over') {
      this.leftSidenav2.toggle();
    }
  }
}
